
























import gql from 'graphql-tag';
import { find, map } from 'lodash';

import ZenMultiselect from '@reciprocity/multiselect';

import { filterPresenterMixin } from './common';

export interface DropdownItem {
  key: string;
  value: string;
}

export default {
  name: 'DropdownFilterAttributePresenter',
  components: {
    ZenMultiselect,
  },
  props: {
    ...filterPresenterMixin.props,
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    internalDisabled(): boolean {
      return this.disabled || this.$apollo.queries.items.loading;
    },
    loading(): boolean {
      return this.$apollo.queries.items.loading;
    },
    computedPlaceholder(): string {
      if (this.$apollo.queries.items.loading) return 'Loading ...';

      return this.placeholder;
    },
    internalValue() {
      return find(this.items, item => item.key === this.value) || [];
    },
  },
  methods: {
    updateActiveItem(item: DropdownItem): void {
      this.$emit('input', item.key);
    },
  },
  apollo: {
    items: {
      query: gql`
        query DropdownValues($type: SearchType!, $attr: String) {
          objectType(name: $type) {
            attrs(name: $attr) {
              validOptions {
                human
                title
              }
            }
          }
        }
      `,
      variables() {
        return {
          type: this.objectType,
          attr: this.attribute,
        };
      },
      update(data) {
        return map(data.objectType.attrs[0].validOptions, o => ({
          key: o.title,
          value: o.human,
        }));
      },
    },
  },
};
